module.exports = __webpack_public_path__ + "img/Weilin Palm Recognition Software.825ccbce.jpg";